import type {MemexItemModel} from '../../../../models/memex-item-model'
import type {ClipboardCellData, ClipboardColumnModel} from './types'

export function extractCellData(
  columnModel: ClipboardColumnModel,
  item: MemexItemModel,
): ClipboardCellData | undefined {
  let repositoryId: number | undefined
  if (item.contentRepositoryId) {
    repositoryId = item.contentRepositoryId
  }

  return {repositoryId, columnModel, item}
}
